import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SequenceClass;
function Sequence() {
  if (SequenceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Sequence');
    SequenceClass = $;
  }
  return SequenceClass;
}
//region block: exports
export {
  Sequence as Sequence1quqbxersk0bb,
};
//endregion

//# sourceMappingURL=Sequence.mjs.map
